var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
import { createAst } from "../ast";
import { ScriptTarget, ScriptKind } from "typescript";
export function parseLocaleJSON(localeSourceCode, languageLocale) {
    if (languageLocale === void 0) { languageLocale = "en"; }
    var localeAst = createAst(localeSourceCode, ScriptTarget.ESNext, ScriptKind.JSON);
    if (localeAst) {
        return parseLocaleAST(localeAst, languageLocale);
    }
}
export function parseLocaleAST(ast, languageLocale) {
    if (languageLocale === void 0) { languageLocale = "en"; }
    var localeMessages = [];
    ast === null || ast === void 0 ? void 0 : ast.forEachChild(function (child) {
        var _a, _b;
        (_b = (_a = child === null || child === void 0 ? void 0 : child.expression) === null || _a === void 0 ? void 0 : _a.properties) === null || _b === void 0 ? void 0 : _b.forEach(function (property) {
            var _a, _b, _c;
            var locale = {
                id: property.name.text,
                value: (_a = property.initializer) === null || _a === void 0 ? void 0 : _a.text,
                locale: languageLocale,
                position: { pos: (_b = property.initializer) === null || _b === void 0 ? void 0 : _b.pos, end: (_c = property.initializer) === null || _c === void 0 ? void 0 : _c.end }
            };
            localeMessages = __spreadArray(__spreadArray([], localeMessages), [locale]);
        });
    });
    return localeMessages;
}
// it preserves original JSON formatting
export function patchLocaleJSON(localeFile, changedMessages, originalMessages) {
    var _a, _b;
    for (var i = changedMessages.length; i >= 0; i--) {
        if (((_a = changedMessages[i]) === null || _a === void 0 ? void 0 : _a.value) == ((_b = originalMessages[i]) === null || _b === void 0 ? void 0 : _b.value)) {
            console.log("Equal");
        }
        else {
            var before = localeFile.substring(0, originalMessages[i].position.pos + 1);
            var after = localeFile.substring(originalMessages[i].position.end - 1);
            localeFile = before + changedMessages[i].value + after;
        }
    }
    return localeFile;
}
